import React from "react";

// External
import styled from "@emotion/styled";
import { colorScheme } from "../../styled/styled";

const Path = styled.path`
  fill: none;
  stroke: ${colorScheme.neutralLightColor};
  stroke-width: 2px;
  stroke-linecap: round;
  stroke-miterlimit: 10;
  stroke-dasharray: 4.03 6.04;
  transition: opacity 0.5s;
`;

const Clusters = ({ plotDim, cluster, currentProjection }) => {
  const show = currentProjection === "tsne" && cluster;
  const { plotWidth, plotHeight } = plotDim;

  return (
    <svg
      className="region-clusters"
      id="clusters"
      xmlns="http://www.w3.org/2000/svg"
      width={plotWidth}
      height={plotHeight}
      viewBox="0 0 800.75 587.91"
      preserveAspectRatio="none"
      // viewBox={`0 0 ${containerWidth + 140} ${plotHeight + 30}`}
      // viewBox={`0 0 ${containerWidth + 140} ${plotHeight + 30}`}
    >
      <Path
        id="eu1"
        className="cluster"
        d="M1002,415c-33-10.32-134.71,85.8-113,135s93,49,166.61,42.56C1126.67,586.34,1044.39,428.25,1002,415Z"
        transform="translate(-795.09 -8.65)"
        opacity={show === "eu" ? 1 : 0}
      />
      <Path
        id="se-eu"
        className="cluster"
        d="M1090,369c-29.86,15.28-65,58-38,84s73,4,101-14,53-48,40-64S1133,347,1090,369Z"
        transform="translate(-795.09 -8.65)"
        opacity={show === "se-eu" ? 1 : 0}
      />
      <Path
        id="arab"
        className="cluster"
        d="M1362.33,444.21c41.56,36.09,52.49,49.21,77.65,32.81s15.31-105-17.5-119.21-100.62-28.43-98.43,10.94S1362.33,444.21,1362.33,444.21Z"
        transform="translate(-795.09 -8.65)"
        opacity={show === "arab" ? 1 : 0}
      />
      <Path
        id="africa1"
        className="cluster"
        d="M1372,233c-50-1.25-71,14-47,48s60,43,89,41,45-21,35-44S1412,234,1372,233Z"
        transform="translate(-795.09 -8.65)"
        opacity={show === "africa" ? 1 : 0}
      />
      )}
      <Path
        id="africa2"
        className="cluster"
        d="M1495,328c-27.29,8.68-22,36-12,69s0,69,27,81,79,3,84-30-13-67-40-91S1517,321,1495,328Z"
        transform="translate(-795.09 -8.65)"
        opacity={show === "africa" ? 1 : 0}
      />
      <Path
        id="s-se-asia"
        className="cluster"
        d="M1359.32,447.84c-33.86-22.85-78.7-35.21-91.13-11.39s31.07,64.2,52.81,80.77,57,34.17,78.7,13.46S1400.74,475.8,1359.32,447.84Z"
        transform="translate(-795.09 -8.65)"
        opacity={show === "s-se-asia" ? 1 : 0}
      />
      <Path
        id="latin"
        className="cluster"
        d="M886,214c-45,24.13-106,69-86,98s87-12,142-41,113-42,116-62S970,169,886,214Z"
        transform="translate(-795.09 -8.65)"
        opacity={show === "latin" ? 1 : 0}
      />
      <Path
        id="pacific"
        class="cluster"
        d="M1106,10c-28.79-3.51-42,20-44,43s1,59,40,60,50-27,48-39S1147,15,1106,10Z"
        transform="translate(-795.09 -8.65)"
        opacity={show === "pacific" ? 1 : 0}
      />
      <Path
        id="all"
        class="cls-1"
        d="M1092.66,10.42C1016,10.42,796.09,169,796.09,302c0,109,40.55,292,181.73,293s617-.36,617-160.68S1339.32,10.42,1092.66,10.42Z"
        transform="translate(-795.09 -8.65)"
        opacity={show === "interregion" ? 1 : 0}
      />
      <Path
        id="others"
        className="cluster"
        d="M1149,271c30,44,48,43,74,29s28-48,6-70-72-66-94-48S1149,271,1149,271Z"
        transform="translate(-795.09 -8.65)"
        opacity={show === "others" ? 1 : 0}
      />
    </svg>
  );
};

export default Clusters;
